import ClayTabs from "@clayui/tabs";
import { UserManagementTotal as AccountsImage } from "@images/index";
import DomainsHeader from "@components/DomainsHeader/DomainsHeader";
import DomainsTable from "@components/DomainsTable/DomainsTable";
import { predefinedValues, tableHeader } from "./DomainsTableConstant";
import { useCallback, useEffect, useState } from "react";
import { axiosHttp } from "@common-services";
import { PATHS } from "@constants";
import { useDispatch, useSelector } from "react-redux";
import { staticStrings } from "@staticStrings";
import {
  setDomainsCardContent,
  setInitDomainIngestion,
  setSearchKeyWord,
  setSelectedPage,
  setTableResponse
} from "@store/filterIngestion/domains/domains.slice";
import { RootState } from "@store/configureStore";
import { DomainsImage, MailsImage } from "@images/index";
import { IFiltersState } from "@interfaces";

const Domains = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [controller, setController] = useState(new AbortController());
  const [payload, setPayload] = useState<IFiltersState[]>([]);

  const endpoints = PATHS.INGESTION.DOMAINS.LIST;
  const dispatch = useDispatch();
  const { sortByColumn, orderBy, selectedPage, searchKeyWord } = useSelector(
    (state: RootState) => state.domains
  );

  const getUrlParams = useCallback(() => {
    return (
      `${endpoints}?` +
      `&sortByColumn=${sortByColumn}&orderBy=${orderBy}` +
      `&pageNo=${selectedPage}&pageSize=${predefinedValues.pageSize}&search=${encodeURIComponent(searchKeyWord)}`
    );
  }, [sortByColumn, orderBy, selectedPage, endpoints, searchKeyWord]);
  const fetchDomainsTable = useCallback(() => {
    //api call for table data
    const newController = new AbortController();
    setController(newController);

    const apiUrl = getUrlParams();
    if (apiUrl) {
      setIsLoading(true);

      axiosHttp
        .post(
          apiUrl,
          {
            filters: payload
          },
          { signal: newController.signal }
        )
        .then((response) => {
          dispatch(setTableResponse(response.data));
          setIsLoading(false);
        })
        .catch((error) => {
          if (error.code !== "ERR_CANCELED") {
            setIsLoading(false);
            console.error("Error:", error);
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, getUrlParams, payload]);

  const fetchDomainsCardContent = useCallback(() => {
    const apiUrl = `${PATHS.INGESTION.DOMAINS.DOMAINS_ACCOUNTS}`;
    axiosHttp
      .post(apiUrl)
      .then((response) => {
        const data = response?.data?.response;
        dispatch(
          setDomainsCardContent([
            {
              headerText: data?.total?.toString() ?? "---",
              bodyText: staticStrings.ingestion.domains.accountsCard,
              image: AccountsImage ?? "",
              id: AccountsImage + 0
            },
            {
              headerText: data?.total_domains?.toString(),
              bodyText: staticStrings.ingestion.domains.domainsCard,
              image: DomainsImage ?? "",
              id: DomainsImage + 1
            },
            {
              headerText: data?.total_emails?.toString(),
              bodyText: staticStrings.ingestion.domains.emailsCard,
              image: MailsImage ?? "",
              id: MailsImage + 1
            }
          ])
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [dispatch]);
  useEffect(() => {
    fetchDomainsCardContent();
  }, [fetchDomainsCardContent]);
  useEffect(() => {
    fetchDomainsTable();
  }, [fetchDomainsTable]);

  const searchKeyWordHandler = (keyWord: string) => {
    dispatch(setSearchKeyWord(keyWord));
    dispatch(setSelectedPage(1));
  };
  useEffect(() => {
    // Cleanup function to abort the previous request when the component unmounts or controller changes
    return () => controller.abort();
  }, [controller]);

  useEffect(() => {
    return () => {
      dispatch(setInitDomainIngestion());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <ClayTabs.Content>
        <ClayTabs.TabPane aria-labelledby="tab-1">
          <div>
            <DomainsHeader
              setSearchKeyWord={searchKeyWordHandler}
              setPayload={setPayload}
            />

            <DomainsTable tableHeader={tableHeader} isLoading={isLoading} />
          </div>
        </ClayTabs.TabPane>
      </ClayTabs.Content>
    </div>
  );
};

export default Domains;
